import { get } from 'lodash';
import { getLogoType } from '../get-logo';
export function getTopSpacerSection(_a) {
    var composerData = _a.composerData, css = _a.css;
    var hasTopSpacer = getLogoType(composerData) !== 'strip';
    var bodyTopPadding = parseInt(get(css, 'so-global-body.paddingTop'), 10) || 0;
    if (hasTopSpacer) {
        return {
            height: bodyTopPadding,
            cssClass: '',
        };
    }
    return null;
}
//# sourceMappingURL=get-top-spacer-section.js.map